import React from 'react'
import { connect } from 'react-redux'
import './index.scss'
import Dialog from '../../common/dialog'
import FindFriends from './find-friends'
import FriendsList from './friends-list'
import SendInvite from './send-invite'
import { collapseLeftToolbar } from '../../../../action/left-toolbar-state-actions'

class Friends extends Dialog {
  constructor(props) {
    super(props)
    this.state = {
      selectedTab: 'friendsList'
    }
  }

  render() {
    const { selectedTab } = this.state,
      { collapseLeftToolbar } = this.props
    return (
      <div className='left-expanded-content-container-friend'
        style={{ overflow: 'hidden' }}>
        <div className='left-expanded-tabs-container'>
          {[
            this.makeTab({
              tab: 'friendsList',
              label: 'Following',
              active: '../../../../../asset/Friends-List_Solid_fill_FFFFFF_stroke_4F4F4F_hdpi.png',
              inactive: '../../../../../asset/Friends-List_Solid_fill_4F4F4F_stroke_FFFFFF_ldpi.png',
            }, '33.3%'),
            this.makeTab({
              tab: 'findFriends',
              label: 'Find & Connect',
              active: '../../../../../asset/Add-Friend_Solid_fill_FFFFFF_stroke_4F4F4F_hdpi.png',
              inactive: '../../../../../asset/Add-Friend_Solid_fill_4F4F4F_stroke_C1C0C0_hdpi.png',
            }, '33.3%'),
            this.makeTab({
              tab: 'invite',
              label: 'Send Invite',
              active: '../../../../../asset/Envelope_Solid_FFFFFF_hdpi.png',
              inactive: '../../../../../asset/Envelope_Solid_4F4F4F_hdpi.png',
            }, '33.3%')
          ]}
        </div>
        {
          selectedTab === 'friendsList' ? <FriendsList /> :
            selectedTab === 'findFriends' ? <FindFriends /> : <SendInvite />
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar())
})

export default connect(mapStateToProps, mapDispatchToProps)(Friends)